import  React,{memo,Fragment} from 'react'

//Recat-bootstrap
import {Image,Button} from 'react-bootstrap'

//Components
import Card from '../../../../components/bootstrap/card'
import Counter from './counter'

//Router
import {Link} from 'react-router-dom'

// Sweetalert
import Swal from "sweetalert2";




const ProductCardListView = memo((props) => {

    function Sweetalert() {
        Swal.fire({
            icon: 'success',
            title: 'Added!',
            text: 'Your item has been Added to the Wishlist.'
        })
    }
    function SweetalertOne() {
        Swal.fire({
            icon: 'success',
            title: 'Added!',
            text: 'Your item has been Added to the Cart.'
        })
    }

    return(
        <Fragment>
            <Card className="iq-product-list-view">
                <Card.Body className=" d-flex flex-wrap justify-content-between">
                    <div className="iq-product-list-left-side d-flex flex-wrap align-items-center trending-card">
                        <Image src={props.productImage} alt="product-details" className="img-fluid trending-img iq-product-img"/>
                        <div className="iq-list-view-left trending-details ms-3">
                            <Link to="/e-commerce/product-details" className="h5 mb-3 d-block iq-product-detail">{props.productName}</Link>                          
                                <h4 className="mb-3">{props.productPrice}</h4>
                            <div>
                                <div className="d-flex align-items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24" fill="none">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M13.1043 4.17701L14.9317 7.82776C15.1108 8.18616 15.4565 8.43467 15.8573 8.49218L19.9453 9.08062C20.9554 9.22644 21.3573 10.4505 20.6263 11.1519L17.6702 13.9924C17.3797 14.2718 17.2474 14.6733 17.3162 15.0676L18.0138 19.0778C18.1856 20.0698 17.1298 20.8267 16.227 20.3574L12.5732 18.4627C12.215 18.2768 11.786 18.2768 11.4268 18.4627L7.773 20.3574C6.87023 20.8267 5.81439 20.0698 5.98724 19.0778L6.68385 15.0676C6.75257 14.6733 6.62033 14.2718 6.32982 13.9924L3.37368 11.1519C2.64272 10.4505 3.04464 9.22644 4.05466 9.08062L8.14265 8.49218C8.54354 8.43467 8.89028 8.18616 9.06937 7.82776L10.8957 4.17701C11.3477 3.27433 12.6523 3.27433 13.1043 4.17701Z" fill="#FFD329"/>
                                    </svg>
                                    <h6 className="mb-0">{props.productRating}</h6>
                                    <small className="ms-2">{props.productRating}k Ratings</small>
                                </div>
                            </div>
                                <Counter/>
                        </div>
                    </div>
                    <div className="iq-list-view-right d-flex flex-column trending-details1 justify-content-center align-items-end">
                        <div>
                        <span className={`bg-soft-${props.statusColor} badge rounded-pill p-2 px-3`}>{props.statusIdentity}</span>
                        </div>
                        <div className="d-flex flex-column text-end">
                            <span>Delivery by, {props.deliveryDate}</span>
                        </div>
                        <div className="iq-list-options d-flex align-items-end gap-2">
                            <Button className="btn btn-info d-flex align-items-center cart-btn gap-2" onClick={Sweetalert}>
                                <span>
                                    <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.4" d="M11.7761 21.8374C9.49311 20.4273 7.37081 18.7645 5.44807 16.8796C4.09069 15.5338 3.05404 13.8905 2.41735 12.0753C1.27971 8.53523 2.60399 4.48948 6.30129 3.2884C8.2528 2.67553 10.3752 3.05175 12.0072 4.29983C13.6398 3.05315 15.7616 2.67705 17.7132 3.2884C21.4105 4.48948 22.7436 8.53523 21.606 12.0753C20.9745 13.8888 19.944 15.5319 18.5931 16.8796C16.6686 18.7625 14.5465 20.4251 12.265 21.8374L12.0161 22L11.7761 21.8374Z" fill="currentColor"></path>
                                        <path d="M12.0109 22.0001L11.776 21.8375C9.49013 20.4275 7.36487 18.7648 5.43902 16.8797C4.0752 15.5357 3.03238 13.8923 2.39052 12.0754C1.26177 8.53532 2.58605 4.48957 6.28335 3.28849C8.23486 2.67562 10.3853 3.05213 12.0109 4.31067V22.0001Z" fill="currentColor"></path>
                                        <path d="M18.2304 9.99922C18.0296 9.98629 17.8425 9.8859 17.7131 9.72157C17.5836 9.55723 17.5232 9.3434 17.5459 9.13016C17.5677 8.4278 17.168 7.78851 16.5517 7.53977C16.1609 7.43309 15.9243 7.00987 16.022 6.59249C16.1148 6.18182 16.4993 5.92647 16.8858 6.0189C16.9346 6.027 16.9816 6.04468 17.0244 6.07105C18.2601 6.54658 19.0601 7.82641 18.9965 9.22576C18.9944 9.43785 18.9117 9.63998 18.7673 9.78581C18.6229 9.93164 18.4291 10.0087 18.2304 9.99922Z" fill="currentColor"></path>
                                    </svg>
                                </span> Wishlist
                            </Button>
                            <Button className="btn btn-primary d-flex align-items-center cart-btn  gap-2" onClick={SweetalertOne}>
                                <span>
                                    <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.4" fillRule="evenodd" clipRule="evenodd" d="M5.91064 20.5886C5.91064 19.7486 6.59064 19.0686 7.43064 19.0686C8.26064 19.0686 8.94064 19.7486 8.94064 20.5886C8.94064 21.4186 8.26064 22.0986 7.43064 22.0986C6.59064 22.0986 5.91064 21.4186 5.91064 20.5886ZM17.1606 20.5886C17.1606 19.7486 17.8406 19.0686 18.6806 19.0686C19.5106 19.0686 20.1906 19.7486 20.1906 20.5886C20.1906 21.4186 19.5106 22.0986 18.6806 22.0986C17.8406 22.0986 17.1606 21.4186 17.1606 20.5886Z" fill="currentColor"></path>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M20.1907 6.34909C20.8007 6.34909 21.2007 6.55909 21.6007 7.01909C22.0007 7.47909 22.0707 8.13909 21.9807 8.73809L21.0307 15.2981C20.8507 16.5591 19.7707 17.4881 18.5007 17.4881H7.59074C6.26074 17.4881 5.16074 16.4681 5.05074 15.1491L4.13074 4.24809L2.62074 3.98809C2.22074 3.91809 1.94074 3.52809 2.01074 3.12809C2.08074 2.71809 2.47074 2.44809 2.88074 2.50809L5.26574 2.86809C5.60574 2.92909 5.85574 3.20809 5.88574 3.54809L6.07574 5.78809C6.10574 6.10909 6.36574 6.34909 6.68574 6.34909H20.1907ZM14.1307 11.5481H16.9007C17.3207 11.5481 17.6507 11.2081 17.6507 10.7981C17.6507 10.3781 17.3207 10.0481 16.9007 10.0481H14.1307C13.7107 10.0481 13.3807 10.3781 13.3807 10.7981C13.3807 11.2081 13.7107 11.5481 14.1307 11.5481Z" fill="currentColor"></path>
                                    </svg>
                                </span> Add to cart
                            </Button>
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </Fragment>
    )

})

ProductCardListView.displayName="ProductCardListView"
export default ProductCardListView